import React from "react";
import { Investment, useInvestmentsId } from "@rentablo/api/apiv1";
import { InvestmentDetailModal } from "@features/investments/investment/components/InvestmentTable/InvestmentDetailModal";

interface Props {
  // The investment of the tapped booking; the overlay is closed without one.
  investmentId?: number;
  // Investments the page has loaded already: the overlay opens with them right
  // away, like the investment list's, and loads only the others (sold ones).
  knownInvestments?: Investment[];
  image?: string | null;
  onClose: () => void;
}

export const BookingInvestmentModal = ({
  investmentId,
  knownInvestments,
  image,
  onClose,
}: Props) => {
  const known = knownInvestments?.find(({ id }) => id === investmentId);
  const { data: loaded } = useInvestmentsId(
    { id: investmentId ?? 0 },
    { enabled: investmentId !== undefined && !known }
  );

  return (
    <InvestmentDetailModal
      investment={known ?? loaded}
      isOpen={investmentId !== undefined}
      onClose={onClose}
      image={image}
    />
  );
};
